import React from 'react';

const LabelText = ({ children, className = '', style }) => (
  <p className={`uppercase tracking-wider ${className}`} style={style}>{children}</p>
);

export default LabelText;
